import { createFileRoute, Outlet, useNavigate, useParams } from "@tanstack/react-router"
import * as React from "react"
import { SubPanelPortal } from "@/components/shell/sub-panel-slot"
import { ChatSessionList } from "@/features/chat/session-list"
import { useHotkeys } from "@/hooks/use-hotkeys"
import { requireCap } from "@/lib/route-guards"

export const Route = createFileRoute("/_app/chat")({
  beforeLoad: requireCap("chat"),
  component: ChatLayout,
})

/** Chat mode: conversation list in the sub-panel (sheet on mobile), page fills the canvas. */
function ChatLayout() {
  const params = useParams({ strict: false }) as { sessionId?: string }
  const activeId = params.sessionId ? Number(params.sessionId) : undefined
  const navigate = useNavigate()
  // ⌘/Ctrl+Shift+O: new chat (same as ChatGPT)
  useHotkeys(
    React.useMemo(
      () => [{ combo: "mod+shift+o", allowInInputs: true, handler: () => void navigate({ to: "/chat" }) }],
      [navigate],
    ),
  )
  return (
    <>
      <SubPanelPortal>
        <ChatSessionList activeId={activeId} />
      </SubPanelPortal>
      <Outlet />
    </>
  )
}
